import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { FC, PropsWithChildren } from "react";

type CrudDialogProps = {
  open: boolean;
  title: string;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  loading: boolean;
  submitLabel?: string;
  maxWidth?: "xs" | "sm" | "md" | "lg";
};

const CrudDialog: FC<PropsWithChildren<CrudDialogProps>> = ({
  open,
  title,
  onClose,
  onSubmit,
  loading,
  submitLabel = "Salvar",
  maxWidth = "sm",
  children,
}): JSX.Element => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <form onSubmit={onSubmit}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent dividers sx={{ display: "flex", flexDirection: "column", gap: "1rem", pt: "1rem !important" }}>
          {children}
        </DialogContent>
        <DialogActions>
          <Button type="button" onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button type="submit" variant="contained" disabled={loading}>
            {loading ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CircularProgress size="1rem" />
                Salvando...
              </Box>
            ) : (
              submitLabel
            )}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CrudDialog;
